module.exports = __webpack_public_path__ + "static/media/pod.94509dd7.svg";